var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.694 11.646h.014-.014Zm.008 0a3.243 3.243 0 0 0 3.23-3.234V3.233A3.12 3.12 0 0 0 8.98.943a3.225 3.225 0 0 0-4.558 0 3.133 3.133 0 0 0-.948 2.29v5.174a3.243 3.243 0 0 0 3.228 3.239Zm1.108 2.613a6.118 6.118 0 0 0 3.282-1.752 6.109 6.109 0 0 0 1.725-4.433.8.8 0 0 0-1.6.046 4.51 4.51 0 1 1-9.015 0 .8.8 0 1 0-1.6-.046 6.11 6.11 0 0 0 5.59 6.263v.764a.955.955 0 0 0 .059.346c.04.11.101.208.178.29A.77.77 0 0 0 7 16a.77.77 0 0 0 .571-.262.877.877 0 0 0 .18-.291.951.951 0 0 0 .06-.346v-.842Z",
    fill: "#6F6F6F"
  })));
};
export default SvgMic;